var _feGaussianBlur;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShapeHomeplateSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 131,
    viewBox: "0 0 32.014583 34.660418",
    id: "svg20973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs20967"
  }, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter8914",
    x: -0.10167822,
    width: 1.2033564,
    y: -0.090854725,
    height: 1.1817094
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.94126328,
    id: "feGaussianBlur8916"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-262.33957)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "#0073cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950619,
      strokeOpacity: 1,
      filter: "url(#filter8914)"
    },
    d: "m 0,272.13583 22.217461,-10e-6 v 8.98916 L 11.108782,297.00004 0,281.12499 Z",
    id: "rect4518-85-9-8-1-0-9",
    transform: "matrix(1.1974506,0,0,1.1796328,2.7051346,-56.015897)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShapeHomeplateSelect);
export default __webpack_public_path__ + "static/media/icon-shape-homeplate-select.764868783b8aa54b83cbf143f08606be.svg";
export { ForwardRef as ReactComponent };